<template>
    <div :class="[companyClass , canScroll]">
        <div class="page-mobilemoneyprovider flex column mb-20">
            <div class="page-header">
				<h1 class="pageTitle">{{pageTitle}} info</h1>
				<h4>{{pageSubtitle}} info</h4>
				<el-breadcrumb separator="/">
					<el-breadcrumb-item :to="{ path: '/' }"><i class="mdi mdi-home-outline"></i></el-breadcrumb-item>
					<el-breadcrumb-item>partners &amp; agents</el-breadcrumb-item>
					<el-breadcrumb-item>ledgers</el-breadcrumb-item>
					<el-breadcrumb-item>{{pageTitle}}</el-breadcrumb-item>
				</el-breadcrumb>
			</div>

			<div class="mt-0 w-100">
				<div style="float: right;">
					<el-button v-show="userPermissionsFilter.addledgers" 
                     type="primary" icon="el-icon-plus" @click="handleNew">
                    </el-button>

					<el-button type="warning" icon="el-icon-tickets"
                    v-show="userPermissionsFilter.viewledgers" 
						@click="goToLedgers" title="view list"></el-button>

					<el-button type="primary"
                     @click="validateAndSave" v-show="!readOnlyMode && canSaveChanges && userPermissionsFilter.addledgers" 
					 :disabled="saveChanges">
                     <i class="mdi mdi-content-save"></i></el-button>

					 <el-button type="warning"
                    v-show="userPermissionsFilter.viewledgers && readOnlyMode" 
						@click="goToEntries" title="view ledger entries"><i class="mdi mdi-reply-all"></i></el-button>
				</div>
			</div>

			<div class="mt-10">
				<el-row :gutter="20">
					<el-col :span="12">
						<span>Account Name</span><span :class="required"> *</span>
                        <el-input placeholder="Ledger Account Name" v-model="ledgerAccount.name"
						name="name" v-validate="'required'" 
						:disabled="readOnlyMode"></el-input>
						<transition name="fade">
                            <span class="danger-text">{{ errors.first('name') }}</span>
                        </transition>
					</el-col>
                    <el-col :span="12">
						<span>Account Base Currency</span><span :class="required"> *</span>
                        <el-select v-model="ledgerAccount.currencyID" filterable clearable placeholder="Select Currency" class="mb-10" 
                        style="width:100%" name="currency" v-validate="'required'" 
						:disabled="readOnlyMode">
                            <el-option
                            v-for="currency in currencies"
                            :key="currency.id"
                            :label="currency.nameCode"
                            :value="currency.id">
                            </el-option>
                        </el-select>
                        <transition name="fade">
                            <span class="danger-text">{{ errors.first('currency') }}</span>
                        </transition>
					</el-col>
				</el-row>

				<el-row :gutter="20" class="mt-10">
					<el-col :span="12">
						<span>Account</span><span :class="required"> *</span>
                        <el-select v-model="ledgerAccount.accountId" filterable clearable placeholder="Select Account" class="mb-10" 
                        style="width:100%" name="beneficiary" v-validate="'required'" 
						@change="accountChanged" :disabled="readOnlyMode">
                            <el-option
                            v-for="benf in companyNames"
                            :key="benf.id"
                            :label="benf.name"
                            :value="benf.id">
                            </el-option>
                        </el-select>
                        <transition name="fade">
                            <span class="danger-text">{{ errors.first('beneficiary') }}</span>
                        </transition>
					</el-col>
					<el-col :span="12">
						<span>Base Currency</span><span :class="required"> *</span>
                        <el-input placeholder="Base Currency" readonly="true" v-model="baseCurrency"></el-input>
					</el-col>
				</el-row>

				<el-row :gutter="20" class="mt-10">
					<el-col :span="12">
						<span>Service Type</span><span :class="required"> *</span>
                        <el-select v-model="ledgerAccount.serviceTypeID" filterable clearable placeholder="Select Service Type" class="mb-10" 
                        style="width:100%" name="servicetype" v-validate="'required'" 
						:disabled="readOnlyMode">
                            <el-option
                            v-for="service in serviceTypes"
                            :key="service.id"
                            :label="service.name"
                            :value="service.id">
                            </el-option>
                        </el-select>
                        <transition name="fade">
                            <span class="danger-text">{{ errors.first('servicetype') }}</span>
                        </transition>
					</el-col>
					<el-col :span="12">
						<span>Service Principal</span><span :class="required"> *</span>
                        <el-select v-model="ledgerAccount.principalID" filterable clearable placeholder="Select Principal" class="mb-10" 
                        style="width:100%" name="principal" v-validate="'required'" 
						:disabled="readOnlyMode">
                            <el-option
                            v-for="principal in principalCompanies"
                            :key="principal.id"
                            :label="principal.name"
                            :value="principal.id">
                            </el-option>
                        </el-select>
                        <transition name="fade">
                            <span class="danger-text">{{ errors.first('principal') }}</span>
                        </transition>
					</el-col>
				</el-row>

				<div class="mt-10">
                    <el-button type="primary" v-show="!readOnlyMode" @click="validateAndSave"><i></i> Save Ledger Account</el-button>
					<el-button type="info" v-show="!readOnlyMode" @click="clearState"><i></i> Reset</el-button>
					<el-button type="success" @click="approveLedger" 
                    v-show="canApproveFinancing"><i></i> Approve</el-button>
                </div>
			</div>

        </div>
    </div>
</template>


<script>
import PermissionsMixins from '@/mixins/PermissionsMixins'
import router from '@/router/' 
import { bus } from '@/main'
import { Validator } from 'vee-validate'

export default {
	name: 'AddLedgerAccount',
	data() {
		return {
			exitTo: '',
			baseCurrency: '',
			ledgerAccount: {
				id: 0,
				name: '',
				accountId: '',
				serviceTypeID: '',
				principalID: '',
				currencyID: '', 
				approved: false
			}
		}
	},
	computed: {
		canSaveChanges() {
			return this.saveChanges && !this.readOnlyMode;
		},
		readOnlyMode() {
			return (this.ledgerAccount.id > 0 && this.ledgerAccount.approved);
		},
        canApproveFinancing() {
            return (this.userPermissionsFilter.approvefinancing && this.ledgerAccount.id > 0 && !this.ledgerAccount.approved)
		}
	},
	methods: {
		createNew() {
			router.push('/addledgeraccount');
            this.clearState();
		},
		goToEntries() {
			this.exitTo = '/financing';
			this.handleExit();
		},
		goToLedgers() {
			this.exitTo = '/ledgers';
			this.handleExit();
		},
		viewledgers() {
			router.push(this.exitTo);
		},
		clearState() {
			this.baseCurrency = '';	
			this.ledgerAccount = {
				id: 0,
				name: '',
				accountId: '',
				serviceTypeID: '',
				principalID: '',
				currencyID: '', 
				approved: false
			};
			this.$validator.reset();
		},
		setBaseCurrency(accountId) {	
			this.baseCurrency = '';		
			this.getCompanyCurrency(accountId)
			.then(result=> {
				if(result){
					this.baseCurrency = result.nameCode;
				}
				else{
					this.infoMessage('no base currency has been set for the beneficiary.');
				}
			})
			.catch(err=> console.log(err));
		},
		accountChanged(e){
			this.propertyChanged();
			this.setBaseCurrency(e);
		},
		validateAndSave() {
			let self = this;
            this.$validator.validateAll()
            .then(result=> {
                if(result){
					self.saveGeneralLedgerAccount(self.ledgerAccount)
					.then(result=> {
						if(result.id > 0){
							self.ledgerAccount = result;
							self.successMessage('Ledger account saved successfully.');
							self.entitySaved();
						}
						else{
							self.errorMessage('Ledger account not saved.');
						}
					})
					.catch(err=> this.errorMessage('An error occured.'));
                }
            })
            .catch(err=> console.log(err));
        },
        approveLedger() {
            this.approveGeneralLedgerAccount(this.ledgerAccount.id)
            .then(result=> {
				this.ledgerAccount.approved = result;
                if(result){
                    this.successMessage('Ledger account approved.');
                    this.entitySaved();
                }
                else{
                    this.errorMessage('Ledger account not approved.');
                }
            })
            .catch(err=> this.errorMessage('An error occured.'));
		}
	},
	created() {
		this.newEvent = 'createNew';
        this.saveEvent = 'validateAndSave';
        this.exitEvent = 'viewledgers';
        this.$on(this.saveEvent, this.validateAndSave);
        this.$on(this.newEvent, this.createNew);
		this.$on(this.exitEvent, this.viewledgers);
		
		this.getCompanyNames();
		this.getCurrencies();
		this.getPricipalCompanies('');
		this.getServices();

		var id = router.currentRoute.params.id;

		this.pageTitle = 'add ledger account';
		this.pageSubtitle = 'create ledger account';

        if(id){
            this.findGeneralLedgerAccount(id)
         	.then(result=> {
			 this.ledgerAccount = result;
			 this.setBaseCurrency(result.accountId);
			 this.pageTitle = `update ledger ${result.name}`;
         });
        }
	},
	mixins: [PermissionsMixins]
}
</script>